export default __webpack_public_path__ + "static/media/arrow-down.7980f1ad.svg";